<template>
  <div class="h-full">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "EmptyRouterView",
};
</script>

<style scoped></style>
